import { render, staticRenderFns } from "./SidebarCategory.vue?vue&type=template&id=3823edb0&"
import script from "./SidebarCategory.vue?vue&type=script&lang=js&"
export * from "./SidebarCategory.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports